import React from 'react'
import { Container } from 'pcln-design-system'
import { ICollectionType, useContentful } from '@pcln/contentful-components'
import PromoBanners from '@/components/MerchModuleWrapper/PromoBanners'
import AdBanner from '@/components/AdBanner'
import { AdBox, AdContent } from '@/components/AdContent'
import AppDownloadWrapper from '@/components/AppDownloadWrapper'
import EmailSignUp from '@/components/EmailSignUp'
import { ANALYTICS_CATEGORY_PACKAGES } from '@/constants/analytics'
import { CustomMerchModule } from '@/types'
import PackagesCarousel from '@/components/PackagesCarousel'

function Content() {
  const toutBanners = useContentful('toutBanners') as ICollectionType
  const promoItems = (toutBanners?.items ||
    []) as ReadonlyArray<CustomMerchModule>

  return (
    <Container size="xl" mb={5}>
      <EmailSignUp
        sourceId="LANDING_PACKAGE"
        category={ANALYTICS_CATEGORY_PACKAGES}
      />
      <PackagesCarousel gaCategory={ANALYTICS_CATEGORY_PACKAGES} />
      <AdContent>
        <AdBox type="primary">
          <div id="div-gpt-ad-1511924707554-0" />
        </AdBox>
        <AdBox type="secondary">
          <div id="div-gpt-ad-1511924575742-0" />
        </AdBox>
        <AdBox type="tertiary">
          <div id="div-gpt-ad-1511924174680-0" />
        </AdBox>
      </AdContent>
      <PromoBanners merchModules={promoItems} />
      <AppDownloadWrapper category={ANALYTICS_CATEGORY_PACKAGES} />
      <AdBanner>
        <div id="div-gpt-ad-1511924263419-0" />
      </AdBanner>
    </Container>
  )
}

export default Content
